import { render, staticRenderFns } from "./referral-info-list.vue?vue&type=template&id=79adb592&scoped=true&"
import script from "./referral-info-list.vue?vue&type=script&lang=js&"
export * from "./referral-info-list.vue?vue&type=script&lang=js&"
import style0 from "./referral-info-list.vue?vue&type=style&index=0&id=79adb592&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79adb592",
  null
  
)

export default component.exports